import React from 'react';

// import { ReactReduxContext } from 'react-redux'

import WidgetLayout1 from './features/layout/Layout1'
import './App.css';

function App(props) {
  return (
    <div className="App">
      <WidgetLayout1 cathVersion={props.cathVersion} funfamId={props.funfamId} />
    </div>
  );
}

export default App;
